// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ElementLibrary-ThankYouDonationDetails{gap:1.5rem}`, "",{"version":3,"sources":["webpack://./src/components/EditorMenus/ElementLibrary/GivingFormViews/ThankYouMessageDonationDetails.scss"],"names":[],"mappings":"AAAA,wCACE,UAAA","sourcesContent":[".ElementLibrary-ThankYouDonationDetails {\n  gap: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
